// tslint:disable:max-line-length
import * as React from 'react'
import logoSrc from './logo.svg'
import './logo.png'

interface ILuminopiaGraphicProps {
  className?: string
}

export class LuminopiaGraphic extends React.PureComponent<ILuminopiaGraphicProps, {}> {
  render() {
    // Correctly typed style object
    const containerStyle: React.CSSProperties = {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    };

    const svgStyle: React.CSSProperties = {
      maxWidth: '250px',
      height: 'auto',
      display: 'block',
      margin: '0 auto',
    };


    return (
      <div style={containerStyle}>
        <img src={logoSrc} alt="Luminopia Logo" style={svgStyle} />
      </div>
    );
  }
}
export interface ILuminopiaLogoVerticalTheme {
  graphic?: string
  lettering?: string
}

interface ILuminopiaLogoVerticalProps {
  className?: string
  theme?: ILuminopiaLogoVerticalTheme
}

export class LuminopiaLogoVertical extends React.PureComponent<ILuminopiaLogoVerticalProps, {}> {
  public render() {
    return (
      <div className={this.props.className}>
        <div className={this.props.theme && this.props.theme.graphic}>
          <LuminopiaGraphic />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/LuminopiaLogo/index.tsx